import React, { useEffect, useState } from "react";

export function ConsentBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // If we're client-side and no consent exists, show it and push default denied state
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      setShow(true);
      const w = window as any;
      w.dataLayer = w.dataLayer || [];
      function gtag() {
        // eslint-disable-next-line prefer-rest-params
        w.dataLayer.push(arguments);
      }
      // @ts-expect-error - gtag is defined locally for GTM consent
      gtag("consent", "default", {
        ad_storage: "denied",
        analytics_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
      });
    } else if (consent === "granted") {
      const w = window as any;
      w.dataLayer = w.dataLayer || [];
      function gtag() {
        // eslint-disable-next-line prefer-rest-params
        w.dataLayer.push(arguments);
      }
      // @ts-expect-error - gtag is defined locally for GTM consent
      gtag("consent", "update", {
        ad_storage: "granted",
        analytics_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
      });
    }
  }, []);

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] bg-foreground/95 backdrop-blur-[16px] text-background shadow-ambient-lg p-4 md:p-6 sm:flex sm:items-center sm:justify-between">
      <div className="ds-body-sm max-w-3xl mr-0 md:mr-6">
        <p className="ds-body-sm-strong mb-1">We value your privacy</p>
        <p className="opacity-60">
          We use cookies to enhance your browsing experience, serve personalized ads or content, and
          analyze our traffic. By clicking &quot;Accept All&quot;, you consent to our use of
          cookies.
        </p>
      </div>
      <div className="mt-4 sm:mt-0 flex flex-col sm:flex-row gap-2 md:gap-3 flex-shrink-0">
        <button
          onClick={() => {
            localStorage.setItem("cookie_consent", "denied");
            setShow(false);
            const w = window as any;
            w.dataLayer = w.dataLayer || [];
            function gtag() {
              // eslint-disable-next-line prefer-rest-params
              w.dataLayer.push(arguments);
            }
            // @ts-expect-error - gtag is defined locally for GTM consent
            gtag("consent", "update", {
              ad_storage: "denied",
              analytics_storage: "denied",
              ad_user_data: "denied",
              ad_personalization: "denied",
            });
          }}
          className="ds-button-label min-h-touch w-full sm:w-auto px-4 py-2.5 sm:py-2 bg-background/10 hover:bg-background/20 rounded-md transition-colors"
        >
          Reject All
        </button>
        <button
          onClick={() => {
            localStorage.setItem("cookie_consent", "granted");
            setShow(false);
            const w = window as any;
            w.dataLayer = w.dataLayer || [];
            function gtag() {
              // eslint-disable-next-line prefer-rest-params
              w.dataLayer.push(arguments);
            }
            // @ts-expect-error - gtag is defined locally for GTM consent
            gtag("consent", "update", {
              ad_storage: "granted",
              analytics_storage: "granted",
              ad_user_data: "granted",
              ad_personalization: "granted",
            });
          }}
          className="ds-button-label min-h-touch w-full sm:w-auto px-4 py-2.5 sm:py-2 bg-primary hover:bg-primary/90 text-primary-foreground rounded-md transition-colors"
        >
          Accept All
        </button>
      </div>
    </div>
  );
}
